<script setup lang="ts">
defineProps<{
  id: string
  title: string
}>()
</script>

<template>
  <section :aria-labelledby="id" class="flex flex-col items-center gap-y-4">
    <Heading as="h2" :id="id" size="small" class="!text-gray-500">{{ title }}</Heading>

    <slot></slot>
  </section>
</template>
